import React from 'react'
// import LoaderButton from '../../components/LoaderButton'
// import FormViewer from '../../components/FormViewer'
// import { chooseWallpaper, translate } from "../../utils/useful";
// import Responsive from '../../components/Responsive';
// import RoomContent from '../../components/views/RoomContent';
// import RoomChat from './RoomChat';
// import RoomMediaTable from './RoomMediaTable';
import DetectRTC from 'detectrtc'
import RoomVideo from './RoomVideo';
import RoomLobby from './RoomLobby';
import StagesManager from '../../components/StagesManager';
import RoomReview from './RoomReview';
import SocketServices from '../../utils/socket.services'
// import { getBoundingClientRect } from "../../utils/functions";
// import { async } from 'three';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { nanoid } from 'nanoid';
import * as actions from '../../stores/actionsList';
import { playSound } from '../../utils/useful';
// import socketServices from '../../utils/socket.services';
// import CustomLoader from '../../components/CustomLoader';

class Room extends React.Component {
    state = {
        roomId: "",
        topicId: nanoid(),
        name: "",
        showAskName: true,
        showWhiteboard: false,
        selectPencil: true,
        WriteText: false,
        chooseImage: false,
        chooseUrl: false,
        currentView: 'tiled',
        userView: 'auto',
        cameras: [],
        positions: [],
        localMediaStream: {},
        myPeerId: {},
        isHttps: false,
        peerLoockupUrl: 'https://extreme-ip-lookup.com/json/?key=demo2',
        myPeerName: '',
        useVideo: true,
        useAudio: true,
        myHandStatus: false,
        isRecScreenStream: false,
        peerConnection: {},
        peerConnections: {},
        remoteMediaStream: {},
        peerMediaElements: {},
        isDocumentOnFullScreen: false,
        isVideoOnFullScreen: false,
        myVideoStatus: {},
        isScreenStreaming: false,
        isButtonsVisible: false,
        isCaptionBoxVisible: false,
        chatRoomBtn: {},
        msgerDraggable: {},
        isChatRoomVisible: false,
        backupIceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
        allPeers: [],
        chatDataChannels: {},
        fileDataChannels: {},
        joinRoomApproved: false,
        joinPendingRequests: [],
        isLoader: false,
        defaultValue: { video: true, audio: true },
        videoOff: false,
        // useAudio: false,
        peopleList: false,
        information: false,
        isLoadingApproveRequest: {}

    }

    peerConnections = {}

    componentDidMount() {
        let path = window.location.href
        // if(Array.isArray())
        let query = path?.split('?')[-1]
        this.configConstraints(query, () => {

            // console.log('path is ss', query)
            // console.log('singn', SocketServices.socket)

            this.initUserMedia()
            this.waitForSocket(50)
            if (this.props.setHeader) {
                this.props.setHeader({
                    'toolbar': null,//this.props.toolbarView,
                    'showToolbar': false,
                    'showFrames': true,
                    'showSettings': true,
                    backAction: this.props.changePage,
                    // title: !this.props.isApplet && '{{lang}}Drive',
                    type: 'rooms'
                })
            }
            // this.subscribeTopic()
        })


        // window.addEventListener("beforeunload", this.handleUnload);


    }
    componentDidUpdate = (prevProps) => {
        // console.log('navigator.onLine', navigator.onLine)
        // if (this.props.settings?.socketStatus != prevProps.settings?.socketStatus && !this.props.settings?.socketStatus) {
        //     // this.retryConnection()
        // }

    }


    componentWillUnmount() {

        // console.log("componentWillUnmount",this.state.isLoadingJoin)

        if (this.state.isLoadingJoin) {
            this.handleCancelRequest()
        }

        if (this.stream) {
            this.stream.getTracks().forEach(function (track) {
                // console.log(track)
                track.stop();
            });
        }



        // window.removeEventListener("beforeunload", this.handleUnload);


    }


    // handleUnload = () => {
    //     console.log("Page is unloading... Sending socket request.");
    //     if (this.isLoadingJoin) {
    //         this.handleCancelRequest()
    //     }
    // };


    configConstraints = (query, cb) => {
        if (query) {

            // console.log('configConstraints')
            if (query.includes('videoCall=false') || query.includes('video=false')) {
                let defaultValue = this.state.defaultValue
                defaultValue.video = false
                this.setState({ defaultValue }, () => {
                    cb()
                })
            }
            else {
                cb()
            }
        }
        else {
            cb()
        }

        // else {
        //     let extra = query?.split('&&')
        //     if (extra.includes('video=false')) {

        //     }
        // }
    }
    setData = (key, value) => {
        this.setState({ [key]: value })
    }


    initUserMedia = () => {

        let id
        if (this.props.windowData.path[this.props.baseUrl.length + 1]) {
            id = this.props.windowData.path[this.props.baseUrl.length + 1]
        }

        // if (this.props.data?.path && this.props.data?.path[1]) {
        //     id = this.props.data?.path[1]
        // }

        // console.log('room id', id)


        this.setState({ roomId: id }, () => {
            this.goToLobby()

        })
        this.constraints = {
            video: {
                width: { ideal: 1024, max: 1920 },
                height: { ideal: 720, max: 1080 }
            },
            audio: {
                echoCancellation: true,
                noiseSuppression: true,
                sampleRate: 44100,
            }
        }
        navigator.mediaDevices.getUserMedia(this.constraints).then(stream => {

            let cameras = this.state.cameras
            let camera = { srcObject: stream, id: "localVideo", local: true }

            let foundCamera = false
            for (let i = 0; i < cameras.length; i++) {
                let camera = cameras[i];

                if (camera.id == 'localVideo') {
                    foundCamera = true
                    camera.srcObject = stream
                }

            }

            if (!foundCamera) {
                cameras.push(camera)
            }

            this.stream = stream;
            this.localMediaStream = this.stream

            // console.log('localmedia 1', localMediaStream);

            this.setState({ cameras: cameras }, () => {
                // console.log('setstated cameras', this.state.cameras);
                //     this.setView(() => {
                //         this.localVideo.srcObject = stream;
                //         this.localVideo.play()
                //     })
                // this.roomVideoView.initSetView()
                if (this.roomLobby && this.roomLobby.playVideo) {
                    this.roomLobby.playVideo()
                }
            })

        }).then(() => {
            if (this.state.defaultValue.video == false) {
                this.stream.getVideoTracks()[0].stop()
            }
        }).catch(function (error) {
            alert(error)
        })
        setTimeout(() => {

            this.initClientPeer()
        }, 200);
        // console.log(this.state.roomId)
    }





    reloadScreenShare = () => {


        console.log('reloadScreenShare')
        if (this.screenStream) {
            let cameras = this.state.cameras
            let camera = { srcObject: this.screenStream, id: "screenShare", local: true }

            let foundCamera = false
            for (let i = 0; i < cameras.length; i++) {
                let camera = cameras[i];

                if (camera.id == "screenShare") {
                    foundCamera = true
                    camera.srcObject = this.screenStream
                }

            }

            console.log('foundCamera',foundCamera)


            if (!foundCamera) {
                cameras.push(camera)
            }

            this.setState({ cameras: cameras }, () => {

                this.attachMediaStream("screenShare", this.screenStream);

            })

        }
        // this.stream = stream;
        // this.localMediaStream = this.stream




    }


    waitForSocket = (leftAttempt) => {

        if (SocketServices.socket?.connected) {
            this.setState({ isLoader: false })

            // console.log('signal', true)
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForSocket(leftAttempt - 1)
                } else {
                }
            }, 400);
        }
    }

    setPeopleList = () => {
        let peopleList = this.state.peopleList
        this.setState({ peopleList: !peopleList })
        this.setState({ information: false })
    }

    setInformation = () => {
        let information = this.state.information
        this.setState({ information: !information })
        // this.setState({ peopleList: false })
    }


    setStateProps = (key, value, cb) => {
        // console.log(key)
        // console.log(value)
        this[key] = value
        this.setState({ [key]: value }, () => {
            cb()
        })
    }




    initScreenPeer = (userId, cb) => {

        if (SocketServices.socket) {
            // console.log('initCLIENTPEER');
            // SocketServices.socket = SocketServices.socket
            let userOwner = userId
            let userAgent = navigator.userAgent.toLowerCase()
            this.isTabletDevice = this.isTablet(userAgent);
            this.isIPadDevice = this.isIpad(userAgent);


            this.peerInfo = this.getPeerInfo();

            this.isMobileDevice = this.peerInfo.isMobileDevice

            // console.log('peer info', this.peerInfo)

            if (!this.peerInfo.isWebRTCSupported) {
                // console.log('error', 'This browser seems not supported WebRTC!');
                return;
            }


            // console.log(this.getPeerInfo())

            // console.log('01. Connecting to signaling server');

            // socket
            // SocketServices.socket = SocketServices.socket//io(ENDPOINT);

            // console.log(SocketServices.socket);


            // const transport = SocketServices.socket.io.engine.transport.name; // in most cases, "polling"
            // // console.log('02. Connection transport', transport);

            // // Check upgrade transport
            // SocketServices.socket.io.engine.on('upgrade', () => {
            //     const upgradedTransport = SocketServices.socket.io.engine.transport.name; // in most cases, "websocket"
            //     // console.log('Connection upgraded transport', upgradedTransport);
            // });
            if (cb) cb()

        } else {
            setTimeout(() => {
                this.initScreenPeer(userId)
            }, 200);
        }

    }




    initClientPeer = () => {
        if (SocketServices.socket) {
            // console.log('initCLIENTPEER');
            // SocketServices.socket = SocketServices.socket
            let userAgent = navigator.userAgent.toLowerCase();

            this.isTabletDevice = this.isTablet(userAgent);
            this.isIPadDevice = this.isIpad(userAgent);


            this.peerInfo = this.getPeerInfo();

            this.isMobileDevice = this.peerInfo.isMobileDevice

            // console.log('peer info', this.peerInfo)

            if (!this.peerInfo.isWebRTCSupported) {
                // console.log('error', 'This browser seems not supported WebRTC!');
                return;
            }


            // console.log(this.getPeerInfo())

            // console.log('01. Connecting to signaling server');

            // socket
            // SocketServices.socket = SocketServices.socket//io(ENDPOINT);

            // console.log(SocketServices.socket);


            // const transport = SocketServices.socket.io.engine.transport.name; // in most cases, "polling"
            // console.log('02. Connection transport', transport);

            // Check upgrade transport
            // SocketServices.socket.io.engine.on('upgrade', () => {
            //     const upgradedTransport = SocketServices.socket.io.engine.transport.name; // in most cases, "websocket"
            //     // console.log('Connection upgraded transport', upgradedTransport);
            // });

            // on receiving data from signaling server...
            // SocketServices.socket.on('connect', this.handleConnect);
            // console.log('socket on', SocketServices.socket);

            // SocketServices.socket.on('addPeer', this.handleAddPeer);
            // SocketServices.socket.on('sessionDescription', this.handleSessionDescription);
            // SocketServices.socket.on('iceCandidate', this.handleIceCandidate);
            // SocketServices.socket.on('whiteboardAction', this.handleWhiteboardAction);
            // SocketServices.socket.on('wbCanvasToJson', this.handleJsonToWbCanvas);

            // SocketServices.socket.on('roomIsLocked', handleUnlockTheRoom);
            // SocketServices.socket.on('roomAction', handleRoomAction);
            // SocketServices.socket.on('serverInfo', handleServerInfo);
            // SocketServices.socket.on('peerName', handlePeerName);
            // SocketServices.socket.on('peerStatus', handlePeerStatus);
            // SocketServices.socket.on('peerAction', handlePeerAction);
            // SocketServices.socket.on('kickOut', handleKickedOut);
            // SocketServices.socket.on('fileInfo', handleFileInfo);
            // SocketServices.socket.on('fileAbort', handleFileAbort);
            // SocketServices.socket.on('videoPlayer', handleVideoPlayer);
            // SocketServices.socket.on('disconnect', this.handleDisconnect);
            // SocketServices.socket.on('removePeer', this.handleRemovePeer);




        } else {
            setTimeout(() => {
                this.initClientPeer()
            }, 200);
        }

    } // end [initClientPeer]









    handleSocket = () => {
        // console.log('handle socket');
        SocketServices.socket.on('addPeer', this.handleAddPeer);
        SocketServices.socket.on('sessionDescription', this.handleSessionDescription);
        SocketServices.socket.on('iceCandidate', this.handleIceCandidate);
        SocketServices.socket.on('disconnect', this.handleDisconnect);
        SocketServices.socket.on('removePeer', this.handleRemovePeer);
        SocketServices.socket.on('updateJoinRequestsList', this.checkApproveRequest)
        SocketServices.socket.on('approvedPending', this.joinApproved)
        SocketServices.socket.on('announceRoomStatus', this.checkPermisions)
        SocketServices.socket.on('roomNewOffer', this.roomNewOffer)
        SocketServices.socket.on('roomNewAnswer', this.roomNewAnswer)
        SocketServices.socket.on('streamReported', this.streamReported)
        SocketServices.socket.on('serverInfo', this.serverInfo)
        SocketServices.socket.on('updateFromPeer', this.updateFromPeer)
        SocketServices.socket.on('peerAskedForTack', this.peerAskedForTack)

    }




    peerAskedForTack = (config) => {
        console.log('peerAskedForTack', config)

        if (config.peer_id) {
            let peerConnection = this.peerConnections[config.peer_id]

            if (peerConnection) {
                const senders = peerConnection.getSenders()

                let videoTrack
                if (config.type == 'screenShare') {
                    [videoTrack] = this.screenStream.getVideoTracks();
                } else {
                    [videoTrack] = this.localMediaStream.getVideoTracks();
                }

                senders.forEach((sender) => {
                    if (sender.track && sender.track.kind === "video") {
                        console.log(`🔄 Replacing video track for peer ${config.peer_id}...`);
                        sender.replaceTrack(videoTrack);
                    }
                });
            }

        }
    }


    updateFromPeer = (config) => {


        let cameras = this.state.cameras

        if (config.key != 'peer_emoji') {

            for (let c = 0; c < cameras.length; c++) {
                let camera = cameras[c];
                if (camera.peer?.id == config.peer_id && !camera.screenShare) {

                    camera[config.key] = config.value
                }
            }
        }

        this.setState({ cameras })
        if (config.key == 'peer_hand' && config.value == true) {

            playSound('raiseHand');
        }

        if (config.key == 'peer_emoji') {

            this.addEmojiToList(config.value, config.peer_id)
        }


    }



    sendMyUpdateToPeers = (key, value) => {

        this.sendToServer('roomUpdateMyInfo', {
            channel: this.state.roomId,
            key,
            value
        })

    }




    serverInfo = (config) => {

        if (config.channel == this.state.roomId) {

            // console.log("serverInfo", config)

            if (config.peers) {


                let newPeers = config.peers ?? []

                // let allPeers = this.state.allPeers
                // let cameras = this.state.cameras
                // let peerConnections = this.peerConnections

                // return
                // console.log("peerConnections", peerConnections)
                // console.log("allPeers", allPeers)
                // console.log("cameras LEN", cameras.length)


                // return
                let finalPeers = []
                let finalCameras = []
                // let finalPeerConnections = {}
                let uniqueHubs = {}

                for (let index = 0; index < newPeers.length; index++) {
                    const newPeer = newPeers[index]
                    // let foundPeer = false
                    // for (let j = 0; j < allPeers.length; j++) {
                    //     const oldPeer = allPeers[j];
                    //     if (oldPeer.peer_id == newPeer.peer_id) {
                    //         foundPeer = true
                    //     }

                    // }

                    finalPeers.push(newPeer)

                    // if (foundPeer) {


                    // for (let i = 0; i < cameras.length; i++) {
                    //     const camera = cameras[i];
                    //     console.log(camera.peer?.id, newPeer.peer_id)
                    //     if (camera.peer?.id == newPeer.peer_id) {
                    //         finalCameras.push(camera)
                    //     }
                    // }

                    // console.log("newPeer",newPeer)

                    uniqueHubs[newPeer.peer_userId] = newPeer

                    // }

                }

                // console.log("cameras", cameras)
                // console.log("myPeerId", this.state.myPeerId)



                // for (let j = 0; j < allPeers.length; j++) {
                //     const oldPeer = allPeers[j];
                //     let found = false
                //     for (let index = 0; index < newPeers.length; index++) {
                //         const newPeer = newPeers[index]
                //         if (newPeer.peer == oldPeer.peer_id || oldPeer.peer_id == this.state.myPeerId) {
                //             found = true
                //         }

                //     }

                //     // if (!found) {
                //     //     // console.log("REMOVE PEER",oldPeer.peer_id)
                //     //     if (peerConnections[oldPeer.peer_id]) peerConnections[oldPeer.peer_id].close();
                //     //     delete peerConnections[oldPeer.peer_id]
                //     // }

                // }

                // console.log("uniqueHubs", uniqueHubs)
                // console.log("finalPeers", finalPeers)
                // console.log("cameras", finalCameras)
                // console.log("cameras Len", finalCameras.length)



                this.setState({ allPeers: finalPeers, uniqueHubs }, () => {

                    // this.setState({ cameras: finalCameras, allPeers: finalPeers, uniqueHubs }, () => {
                    this.initSetView(0, () => {

                    })
                })
                // if (peer_id in peerMediaElements) {
                //     peerMediaElements[peer_id].parentNode.removeChild(peerMediaElements[peer_id]);
                //     this.adaptAspectRatio();
                // }

            }

        }
    }



    streamReported = (config) => {

        console.log("streamReported config", config)

        if (config.status == 'stop') {

            this.removeStreamFromScreen(config?.meta?.stream)
        }
    }



    removeStreamFromScreen = (streamId) => {


        let cameras = this.state.cameras
        cameras.forEach((camera, index) => {
            if (camera.stream == streamId) {
                cameras.splice(index, 1)
            }
        });
        this.setState({ cameras }, () => {
            this.initSetView(0, () => {

            })
        })
    }




    subscribeTopic = () => {

        SocketServices.addTopic(this.state.topicId, this.state.roomId, 'user', null, this.handleSocket)
        // console.log('',this.props.potentialUser)

    }
    // handleSocket = () => {

    // }
    /**
    * When a user leaves a channel (or is disconnected from the signaling server) everyone will recieve a 'removePeer' message
    * telling them to trash the media channels they have open for those that peer. If it was this client that left a channel,
    * they'll also receive the removePeers. If this client was disconnected, they wont receive removePeers, but rather the
    * signaling_socket.on('disconnect') code will kick in and tear down all the peer sessions.
    * @param {object} config data
    */
    handleRemovePeer = (config) => {
        // console.log('Signaling server said to remove peer:', config);

        // console.log("handleRemovePeer", config)
        let peer_id = config.peer_id;
        let chatDataChannels = this.state.chatDataChannels
        let peerConnections = this.peerConnections
        let fileDataChannels = this.state.fileDataChannels
        let peerMediaElements = this.state.peerMediaElements
        let allPeers = this.state.allPeers
        let cameras = this.state.cameras

        // console.log(JSON.stringify(cameras))

        for (let i = cameras.length - 1; i >= 0; i--) {
            const camera = cameras[i];

            // console.log(camera)

            if (camera.peer?.id == peer_id) {
                cameras.splice(i, 1)
            }
        }

        // console.log(JSON.stringify(cameras))

        // cameras.forEach((camera, index) => {
        //     if (camera.id == peer_id) {
        //         cameras.splice(index, 1)
        //     }
        // });
        this.setState({ cameras }, () => {
            this.initSetView(0, () => {

            })
        })
        // if (peer_id in peerMediaElements) {
        //     peerMediaElements[peer_id].parentNode.removeChild(peerMediaElements[peer_id]);
        //     this.adaptAspectRatio();
        // }
        if (peer_id in peerConnections) peerConnections[peer_id].close();

        this.msgerRemovePeer(peer_id);

        delete chatDataChannels[peer_id];
        delete fileDataChannels[peer_id];
        delete peerConnections[peer_id];
        delete peerMediaElements[peer_id];
        delete allPeers[peer_id];

        // playSound('removePeer');
        this.setState({ chatDataChannels, fileDataChannels, peerConnections, peerMediaElements, allPeers })

        // console.log('ALL PEERS', allPeers);
    }



    initSetView = (index, cb) => {
        if (this.roomVideoView) {
            // console.log('!setViewSEC', index)
            this.roomVideoView.initSetView(() => {
                if (cb)
                    cb()
            })
        }
        else {
            setTimeout(() => {
                // console.log('!setViewERR', index)
                if (index < 30) {
                    this.initSetView((index + 1), cb)
                } else {
                    if (cb)
                        cb()
                }
            }, 100);
        }
    }
    /**
   * Disconnected from Signaling Server.
   * Tear down all of our peer connections and remove all the media divs.
   * @param {object} reason of disconnection
   */
    handleDisconnect = (reason) => {
        // console.log('Disconnected from signaling server', { reason: reason });

        // let cameras = this.state.cameras


        // for (let peer_id in peerMediaElements) {
        //     peerMediaElements[peer_id].parentNode.removeChild(peerMediaElements[peer_id]);
        //     this.adaptAspectRatio();
        // }
        for (let peer_id in this.peerConnections) {
            this.peerConnections[peer_id].close();
            this.msgerRemovePeer(peer_id);
        }
        let chatDataChannels = {};
        let fileDataChannels = {};
        let peerConnections = {};
        let peerMediaElements = {};
        this.setState({ chatDataChannels, fileDataChannels, peerConnections, peerMediaElements })
    }

    /**
   * Remove participant from chat room lists
   * @param {string} peer_id socket.id
   */
    msgerRemovePeer = (peer_id) => {
        let msgerPrivateDiv = document.getElementById(peer_id + '_pMsgDiv');
        if (msgerPrivateDiv) {
            let peerToRemove = msgerPrivateDiv.firstChild;
            while (peerToRemove) {
                msgerPrivateDiv.removeChild(peerToRemove);
                peerToRemove = msgerPrivateDiv.firstChild;
            }
            msgerPrivateDiv.remove();
        }
    }


    /**
    * The offerer will send a number of ICE Candidate blobs to the answerer so they
    * can begin trying to find the best path to one another on the net.
    * @param {object} config data
    */
    handleIceCandidate = (config) => {
        this.retryHandleIceCandidate(config, 0)

    }




    retryHandleIceCandidate = (config, tryTime, cb) => {
        let peerConnections = this.peerConnections
        let peer_id = config.peer_id;
        if (peerConnections[peer_id] && peerConnections[peer_id].addIceCandidate) {
            let ice_candidate = config.ice_candidate;
            // console.log('config.peer_id', config.peer_id)
            // https://developer.mozilla.org/en-US/docs/Web/API/RTCIceCandidate
            peerConnections[peer_id].addIceCandidate(new RTCIceCandidate(ice_candidate)).catch((err) => {
                // console.error('[Error] addIceCandidate', err);
            });
        }
        else {
            if (tryTime < 20) {

                setTimeout(() => {
                    // console.log('itsDONESession', false)
                    this.retryHandleIceCandidate(config, (tryTime + 1), cb)
                }, 30);
            }

        }

    }
    handleAddPeer = async (config) => {

        if (config.channel == this.state.roomId) {
            // console.log("addPeer", JSON.stringify(config));

            let peer_id = config.peer_id;
            let peer = config.peer;

            let peers = config.peers;
            let should_create_offer = config.should_create_offer;
            let iceServers = config.iceServers;
            let peerConnections = this.peerConnections
            let allpeers = this.state.allPeers ?? {}
            // console.log('peerconnections', this.peerConnections)
            if (peer_id in peerConnections) {
                // This could happen if the user joins multiple channels where the other peer is also in.
                // console.log('Already connected to peer', peer_id);
                return;
            }

            // console.log("handleAddPeer", config)


            if (!iceServers) iceServers = this.state.backupIceServers;
            // console.log('iceServers', iceServers[0]);

            // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection
            let peerConnection = new RTCPeerConnection({ iceServers: iceServers })
            // console.log('peerConnectionpeerConnection', peerConnection)
            // let testConnection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

            // console.log('testConnection', testConnection)
            this.peerConnections[peer_id] = peerConnection;
            allpeers[peer_id] = peer
            // console.log("peerConnections", this.peerConnections)
            // SocketServices.socket?.addEventListener('connected', () => {
            //     console.log('socketServices.socketc', SocketServices.socket.connected)
            // })
            // console.log(this.props.settings, 'this.props.settings')

            // this.props.settings?.addEventListener('socketStatus', () => {
            //     if (this.props.settings.socketStatus == false) {
            //         this.retryConnection(peerConnections, peer_id);
            //     }
            // })onIceConnectionChange
            // setTimeout(() => {

            //     peerConnections[peer_id].onIceConnectionChange = (ev) => {
            //         // console.log('ICE Connection State changed event ev', ev)
            //     }
            //     // console.log('peerConnections[peer_id]', peerConnections[peer_id])
            //     peerConnections[peer_id].addEventListener('iceconnectionstatechange', () => {
            //         // console.log('ICE Connection State:', peerConnections[peer_id].iceConnectionState);

            //         // Check if the connection is disconnected
            //         if (peerConnections[peer_id].iceConnectionState === 'disconnected') {
            //             // this.retryConnection(peerConnections, peer_id);
            //         }
            //     });
            // }, 30);

            // console.log("peer_id")
            // console.log(peer_id)
            // console.log(peerConnections)

            // console.log('config peers ', config.peers);
            // let allPeers = peers;
            // this.peerConnections = peerConnections
            // this.setState({ peerConnection, peerConnections, allPeers }, async () => {

            // return
            // console.log('[RTCPeerConnection] - PEER_ID', peer_id); // the connected peer_id
            // console.log('[RTCPeerConnection] - PEER-CONNECTIONS', peerConnections); // all peers connections in the room expect myself
            // console.log('[RTCPeerConnection] - PEERS', peers); // all peers in the room



            // As P2P check who I am connected with
            // let connectedPeersName = [];
            // for (peer_id in peerConnections) {

            //     if (!peers[peer_id]) {
            //         peers[peer_id] = {}
            //     }

            //     connectedPeersName.push({
            //         peer_name: peers[peer_id]['peer_name'],
            //     });
            // }
            // console.log('[RTCPeerConnection] - CONNECTED TO', JSON.stringify(connectedPeersName));
            // console.log('info', 'Connected to: ' + JSON.stringify(connectedPeersName));
            // setTimeout(async () => {
            // console.log('after handlepeer ', JSON.parse(JSON.stringify(this.peerConnections)), peer_id)
            await this.handlePeersConnectionStatus(peer_id);
            // await this.msgerAddPeers(peers);
            await this.handleOnIceCandidate(peer_id);
            await this.handleOnTrack(peer_id, peer);
            // setTimeout(async () => {
            await this.handleAddTracks(peer_id);
            await this.handleRTCDataChannels(peer_id);
            if (should_create_offer) {
                await this.handleRtcOffer(peer_id);
            }

            // }, 1000);

            // }, 500);


            // setTimeout(() => {
            //     console.log(this.peerConnections)
            // }, 2000);
            // })
        }

        // await wbUpdate();
        // playSound('addPeer');
    }
    /**
    * Peers exchange session descriptions which contains information about their audio / video settings and that sort of stuff. First
    * the 'offerer' sends a description to the 'answerer' (with type "offer"), then the answerer sends one back (with type "answer").
    * @param {object} config data
    */
    handleSessionDescription = (config) => {
        // console.log('Remote Session Description', config);
        this.retryHandleSessionDescription(config, 0)

    }
    retryHandleSessionDescription = (config, tryTime, cb) => {

        let peer_id = config.peer_id;
        if (this.peerConnections[peer_id] && this.peerConnections[peer_id].setRemoteDescription) {
            // console.log('itsDONESession', true)

            let peerConnections = this.peerConnections
            // console.log('peerConnections', JSON.parse(JSON.stringify(peerConnections)))
            // console.log('peerConnections', JSON.parse(JSON.stringify(peer_id)))
            let remote_description = config.session_description;

            // console.log('remote_description', remote_description)
            // https://developer.mozilla.org/en-US/docs/Web/API/RTCSessionDescription
            let description = new RTCSessionDescription(remote_description);

            // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/setRemoteDescription
            peerConnections[peer_id]
                .setRemoteDescription(description)
                .then(() => {
                    // console.log('setRemoteDescription done!');
                    if (remote_description.type == 'offer') {
                        // console.log('Creating answer');
                        // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/createAnswer
                        peerConnections[peer_id]
                            .createAnswer()
                            .then((local_description) => {
                                // console.log('Answer description is: ', local_description);
                                // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/setLocalDescription
                                peerConnections[peer_id]
                                    .setLocalDescription(local_description)
                                    .then(() => {
                                        this.sendToServer('roomRelaySDP', {
                                            peer_id: peer_id,
                                            session_description: local_description,
                                        });
                                        // console.log('Answer setLocalDescription done!');
                                    })
                                    .catch((err) => {
                                        // console.error('[Error] answer setLocalDescription', err);
                                        // console.log('error', 'Answer setLocalDescription failed ' + err);
                                    });
                            })
                            .catch((err) => {
                                // console.error('[Error] creating answer', err);
                            });
                    } // end [if type offer]
                })
                .catch((err) => {
                    // console.error('[Error] setRemoteDescription', err);
                });
        }
        else {
            if (tryTime < 20) {

                setTimeout(() => {
                    console.log('itsDONESession', false)
                    this.retryHandleSessionDescription(config, (tryTime + 1), cb)
                }, 30);
            }
        }
    }
    /**
    * Only one side of the peer connection should create the offer, the signaling server picks one to be the offerer.
    * The other user will get a 'sessionDescription' event and will create an offer, then send back an answer 'sessionDescription' to us
    * @param {string} peer_id socket.id
    */
    handleRtcOffer = async (peer_id) => {
        let peerConnections = this.peerConnections
        // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/onnegotiationneeded
        peerConnections[peer_id].onnegotiationneeded = () => {
            // console.log('Creating RTC offer to', peer_id);
            // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/createOffer
            peerConnections[peer_id]
                .createOffer()
                .then((local_description) => {
                    // console.log('Local offer description is', local_description);
                    // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/setLocalDescription
                    peerConnections[peer_id]
                        .setLocalDescription(local_description)
                        .then(() => {
                            this.sendToServer('roomRelaySDP', {
                                peer_id: peer_id,
                                session_description: local_description,
                            });
                            // this.setState({ peerConnections })
                            // console.log('Offer setLocalDescription done!');
                        })
                        .catch((err) => {
                            // console.error('[Error] offer setLocalDescription', err);
                            // console.log('error', 'Offer setLocalDescription failed ' + err);
                        });
                })
                .catch((err) => {
                    // console.error('[Error] sending offer', err);
                });
        };
        // this.setState({ peerConnections })
    }




    roomNewOffer = (config) => {

        // console.log("roomNewOffer", config.peer_id)
        // console.log("this.peerConnections", this.peerConnections)


        let peerConnection = this.peerConnections[config.peer_id]

        // console.log("peerConnection", peerConnection)


        if (peerConnection) {

            // this.handleRtcOffer(config.peer_id)
            try {
                peerConnection.setRemoteDescription(new RTCSessionDescription(config.offer)).then(() => {
                    peerConnection.createAnswer().then((answer) => {
                        peerConnection.setLocalDescription(answer).then(() => {

                            let channel = this.state?.roomId

                            SocketServices.socket.emit("roomAnswer", { channel, answer, recipient: config.peer_id });
                        })
                    })
                })
            } catch (err) {
                console.log("roomNewOffer", err)
            }
        }
    }

    roomNewAnswer = async (config) => {

        // console.log("roomNewAnswer", config.peer_id)
        let peerConnection = this.peerConnections[config.peer_id]

        // console.log("peerConnection", peerConnection)

        if (peerConnection) {
            await peerConnection.setRemoteDescription(new RTCSessionDescription(config.answer));
        }

    }



    /**
  * Handle peer audio volume
  * @param {object} data peer audio
  */
    handlePeerVolume = (data) => {
        let peer_id = data.peer_id;
        let element = document.getElementById(peer_id + '_pitch_bar');
        let remoteVideoWrap = document.getElementById(peer_id + '_videoWrap');
        let remoteVideoBorder = document.documentElement.style.getPropertyValue('--elem-border-color');
        let volume = data.volume + 25; //for design purpose
        if (!element) return;
        if (volume > 50) {
            element.style.backgroundColor = 'orange';
        }
        element.style.height = volume + '%';
        remoteVideoWrap.style.border = '1px solid rgb(255 255 255 / 32%)';
        setTimeout(function () {
            element.style.backgroundColor = '#19bb5c';
            element.style.height = '0%';
            remoteVideoWrap.style.border = remoteVideoBorder;
        }, 700);
    }
    /**
    * Secure RTC Data Channel
    * https://developer.mozilla.org/en-US/docs/Web/API/RTCDataChannel
    * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/createDataChannel
    * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/ondatachannel
    * https://developer.mozilla.org/en-US/docs/Web/API/RTCDataChannel/onmessage
    * @param {string} peer_id socket.id
    */
    handleRTCDataChannels = async (peer_id) => {
        let peerConnections = this.peerConnections
        peerConnections[peer_id].ondatachannel = (event) => {
            // console.log('handleRTCDataChannels ' + peer_id, event);
            event.channel.onmessage = (msg) => {
                switch (event.channel.label) {
                    case 'mirotalk_chat_channel':
                        try {
                            let dataMessage = JSON.parse(msg.data);
                            switch (dataMessage.type) {
                                case 'chat':
                                    this.handleDataChannelChat(dataMessage);
                                    break;
                                case 'speech':
                                    this.handleDataChannelSpeechTranscript(dataMessage);
                                    break;
                                case 'micVolume':
                                    this.handlePeerVolume(dataMessage);
                                    break;
                            }
                        } catch (err) {
                            // console.error('mirotalk_chat_channel', err);
                        }
                        break;
                    case 'mirotalk_file_sharing_channel':
                        try {
                            let dataFile = msg.data;
                            this.handleDataChannelFileSharing(dataFile);
                        } catch (err) {
                            // console.error('mirotalk_file_sharing_channel', err);
                        }
                        break;
                }
            };
        };
        // this.setState({ peerConnections })
        // this.createChatDataChannel(peer_id);
        // this.createFileSharingDataChannel(peer_id);
    }
    /**
     * Create Chat Room Data Channel
    * @param {string} peer_id socket.id
    */
    createChatDataChannel = (peer_id) => {
        let peerConnections = this.peerConnections
        let chatDataChannels = this.state.chatDataChannels
        chatDataChannels[peer_id] = peerConnections[peer_id].createDataChannel('mirotalk_chat_channel');
        chatDataChannels[peer_id].onopen = (event) => {
            // console.log('chatDataChannels created', event);
        };
        this.setState({ chatDataChannels })

    }
    /**
  * Create File Sharing Data Channel
  * @param {string} peer_id socket.id
  */
    createFileSharingDataChannel = (peer_id) => {
        let peerConnections = this.peerConnections
        let fileDataChannels = this.state.fileDataChannels
        fileDataChannels[peer_id] = peerConnections[peer_id].createDataChannel('mirotalk_file_sharing_channel');
        fileDataChannels[peer_id].binaryType = 'arraybuffer';
        fileDataChannels[peer_id].onopen = (event) => {
            // console.log('fileDataChannels created', event);
        };
        this.setState({ fileDataChannels })
    }
    /**
   * Handle text transcript getting from peers
   * @param {object} config data
   */
    handleDataChannelSpeechTranscript = (config) => {
        this.handleSpeechTranscript(config);
    }
    /**
        * handle Incoming Data Channel Chat Messages
        * @param {object} dataMessage chat messages
        */
    handleDataChannelChat = (dataMessage) => {
        if (!dataMessage) return;

        let msgFrom = dataMessage.from;
        let msgTo = dataMessage.to;
        let msg = dataMessage.msg;
        let msgPrivate = dataMessage.privateMsg;
        let myPeerName = this.state.myPeerName

        // private message but not for me return
        if (msgPrivate && msgTo != myPeerName) return;

        // console.log('handleDataChannelChat', dataMessage);
        // chat message for me also
        if (!this.state.isChatRoomVisible) {
            this.showChatRoomDraggable();
            this.statechatRoomBtn.className = 'fas fa-comment-slash';
        }
        // playSound('chatMessage');
        // setPeerChatAvatarImgName('left', msgFrom);
        // appendMessage(msgFrom, leftChatAvatar, 'left', msg, msgPrivate);
    }

    /**
   * Show msger draggable on center screen position
   */
    showChatRoomDraggable = () => {
        // playSound('newMessage');
        if (this.isMobileDevice) {
            // buttonsBar.style.display = 'none';
            this.isButtonsVisible = false;
        }
        let chatRoomBtn = this.state.chatRoomBtn
        let msgerDraggable = this.state.msgerDraggable
        chatRoomBtn.className = 'fas fa-comment-slash';
        msgerDraggable.style.top = '50%';
        msgerDraggable.style.left = this.isMobileDevice ? '50%' : '25%';
        msgerDraggable.style.display = 'flex';
        this.isChatRoomVisible = true;
        this.setState({ chatRoomBtn, msgerDraggable })
        // only for desktop
        if (!this.isMobileDevice) {
            // this.setTippy(chatRoomBtn, 'Close the chat', 'right-start');
        }
    }
    handleAddTracks = async (peer_id) => {

        // console.log("handleAddTracks", peer_id)

        this.retryAddTracks(peer_id, 0)
    }


    retryAddTracks = (peer_id, tryTime, cb) => {
        let localMediaStream = this.localMediaStream
        let peerConnections = this.peerConnections
        if (peerConnections[peer_id] && peerConnections[peer_id].addTrack) {
            // console.log('itsDONE', true)

            if (this.localMediaStream) {
                localMediaStream.getTracks().forEach((track) => {

                    // console.log('[ADD TRACK] kind - ' + track.kind);
                    // console.log('[ADD TRACK] kind - ' + peerConnections[peer_id]);
                    // console.log('[ADD TRACK] Ontrack - ' + peerConnections[peer_id].onTrack);
                    // if (this.screenStream) {

                    //     peerConnections[peer_id].addTrack(track, this.localMediaStream, this.screenStream)

                    // } else {
                    peerConnections[peer_id].addTrack(track, localMediaStream);

                    // }


                    // this.setState({ peerConnections })
                })

                // if (this.localMediaStream) {
                SocketServices.socket.emit('reportStream', { channel: this.state.roomId, status: 'add', type: "camera", meta: { stream: this.localMediaStream.id, } });
            }
            // if (peerConnections[peer_id].setLocalDescription) {
            //     peerConnections[peer_id].createOffer().then((offer) => {
            //         peerConnections[peer_id].setLocalDescription(offer).then(() => {
            //             let channel = this.state.roomId
            //             SocketServices.socket.emit('roomOffer', { channel, offer, recipient: peer_id, type: "camera", });
            //         })
            //     })
            // }

            // console.log("retryAddTracks", this.screenStream)
            if (this.screenStream) {
                setTimeout(() => {

                    // this.screenStream.getTracks().forEach((track) => {

                    // console.log('[ADD TRACK] kind - ' + track.kind, this.screenStream.id);
                    // console.log('[ADD TRACK] kind - ' + peerConnections[peer_id]);
                    // console.log('[ADD TRACK] Ontrack - ' + peerConnections[peer_id].onTrack);

                    // peerConnections[peer_id].addTrack(track, this.screenStream);
                    this.screenStream.getTracks().forEach(async track => {
                        if (peerConnections[peer_id].addTrack) {
                            // track.type = "screenshare"
                            // peerConnections[peer_id].addTrack(track, this.localMediaStream, this.screenStream)
                            peerConnections[peer_id].addTrack(track, this.localMediaStream, this.screenStream)


                        }
                    })

                    SocketServices.socket.emit('reportStream', { channel: this.state.roomId, status: 'add', type: "screenShare", meta: { stream: this.screenStream.id, } });

                    // if (peerConnections[peer_id].setLocalDescription) {
                    //     peerConnections[peer_id].createOffer().then((offer) => {
                    //         peerConnections[peer_id].setLocalDescription(offer).then(() => {
                    //             let channel = this.state.roomId
                    //             SocketServices.socket.emit('roomOffer', { channel, offer, recipient: peer_id, type: "screenShare", });
                    //         })
                    //     })
                    // }

                    // this.setState({ peerConnections })
                    // })
                }, 500);

            }




            // if (this.screenStream) {
            //     setTimeout(() => {
            //         SocketServices.socket.emit('reportStream', { channel: this.state.roomId, status: 'add', type: "screenShare", meta: { stream: this.screenStream.id, } });

            //     }, 700)
            // }

            // SocketServices.socket.emit('reportStream', { channel: this.state.roomId, status: 'add', type: "camera", meta: { stream: localMediaStream.id, } });

        } else {
            if (tryTime < 20) {
                setTimeout(() => {
                    // console.log('itsDONE', false)
                    this.retryAddTracks(peer_id, (tryTime + 1), cb)
                }, 30);
            }
        }
    }



    UpdateShareScreenToPeers = (stream, localAudioTrackChange = false) => {
        // console.log('allpeers', this.state.allPeers);
        // console.log('peer connection', this.state.peerConnections);

        // console.log("UpdateShareScreenToPeers")
        let peerConnections = this.peerConnections
        // this.setState({ isSharingScreen: true })
        // this.shareScreenStream = stream
        let previsousStream = this.screenStream
        this.screenStream = stream

        if (stream) {


            let cameras = this.state.cameras

            let camera = { srcObject: this.screenStream, id: "screenShare", local: true, screenShare: true, peer: { name: "Presentation", id: "screenShare" } }
            // this.sharedScreen = { id: "screenShare", streamId: stream.id }
            cameras.push(camera)

            // console.log(cameras)
            this.setState({ cameras }, () => {

                // console.log("UpdateShareScreenToPeers")
                // console.log('!camera', cameras, this.roomVideoView.localVideo);
                this.setView(0, async () => {
                    // console.log('9setView1786')

                    // this.roomVideoView.setView(async () => {

                    // this.roomVideoView?.initSetView()
                    // console.log('peerConnections', peerConnections)

                    for (let peer_id in peerConnections) {
                        // console.log("peerConnections", peerConnections)
                        // console.log("peerConnections ID", peerConnections[peer_id])
                        // console.log("STREAM", stream)
                        // console.log("peer_id")
                        // console.log(peer_id)
                        // console.log(this.screenStream)

                        // if (this.screenStream) {
                        this.screenStream.getTracks().forEach(async track => {
                            if (peerConnections[peer_id].addTrack) {
                                // track.type = "test"
                                // peerConnections[peer_id].addTrack(track, this.localMediaStream, this.screenStream)
                                peerConnections[peer_id].addTrack(track, this.localMediaStream, this.screenStream)


                            }
                        })

                        peerConnections[peer_id].createOffer().then((offer) => {
                            peerConnections[peer_id].setLocalDescription(offer).then(() => {
                                let channel = this.state.roomId
                                SocketServices.socket.emit('roomOffer', { channel, offer, recipient: peer_id, type: "screenShare", meta: { stream: stream.id, } });
                            })
                        })

                        // this.handleRtcOffer(peer_id)
                        // }
                        // await this.props.handleOnTrack(peer_id, this.props.allPeers,stream)

                    }


                    SocketServices.socket.emit('reportStream', { channel: this.state.roomId, status: 'add', type: "screenShare", meta: { stream: stream.id, } });

                    // setTimeout(() => {
                    //     for (let j = 0; j < cameras.length; j++) {
                    //         const camera = cameras[j];

                    console.log("cameras", cameras)
                    this.attachMediaStream("screenShare", this.screenStream);

                    // setTimeout(() => {
                    //     this.setView(0, () => { })
                    // }, 50);
                    //     }
                    // }, 100);



                    // await this.props.attachMediaStream(this.props.remoteMediaStream, stream); // newstream
                    // })
                })
            })

        } else {

            // console.log("HEREEE")
            // let camera = { srcObject: this.screenStream, id: "screenShare", local: true, peer: { peer_name: "Presentation", id: "screenShare" } }
            let cameras = this.state.cameras
            let cindex
            cameras.forEach((camera, index) => {
                if (camera.id == 'screenShare') {
                    cindex = index
                }
            });
            if (cindex != null) {
                cameras.splice(cindex, 1)
            }
            this.setState({ cameras }, () => {
                this.setView(0, async () => {
                    // console.log('9setView1222')
                    // this.roomVideoView.setView(async () => {
                    for (let peer_id in peerConnections) {



                        // peerConnections[peer_id].removeStream(this.screenStream)
                        previsousStream.getTracks().forEach(async track => {

                            track.stop()
                            const sender = peerConnections[peer_id].getSenders().find(s => s.track === track);

                            // console.log("sender", sender)
                            if (peerConnections[peer_id].removeTrack) {
                                peerConnections[peer_id].removeTrack(sender)
                            }
                        })

                        peerConnections[peer_id].createOffer().then((offer) => {
                            peerConnections[peer_id].setLocalDescription(offer).then(() => {
                                // socket.emit("offer", offer);
                                let channel = this.state.roomId
                                SocketServices.socket.emit('roomOffer', { channel, offer, recipient: peer_id, type: 'stop_screenShare', meta: { stream: previsousStream.id, } });
                            })
                        })

                    }

                    SocketServices.socket.emit('reportStream', { channel: this.state.roomId, status: 'stop', type: "screenShare", meta: { stream: previsousStream.id, } });

                    // this.screenStream.getTracks().forEach(track => track.stop())

                    // })
                })
            })

        }
    }

    /**
   * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/ontrack
   * @param {string} peer_id socket.id
   * @param {object} peers all peers info connected to the same room
   */
    handleOnTrack = async (peer_id, peer) => {
        // console.log('handleOnTrack !!');
        // console.log('peer_id, ', peer_id);

        // let peerConnections = this.peerConnections
        // console.log('[ON TRACK] - peer_id', peer_id);
        // console.log('peerconnection1', peerConnections[peer_id]);
        // console.log('peerconnection2', peerConnections);

        this.peerConnections[peer_id].ontrack = (event) => {

            // event.track.onended = () => {
            //     console.log("TRACK ENDED")
            //     // for any streams in e.stream check if their active flag is false
            // }
            // console.log("ON TRACK!!", event)
            // let remoteVideoStream = document.getElementById(peer_id + '_video');
            // console.log('remoteVideoStream');
            // console.log(remoteVideoStream);
            // let peer_name = peers[peer_id]['peer_name'];
            // let kind = event.track.kind;
            // console.log('info', '[ON TRACK] - peer_name: ' + peer_name + ' kind: ' + kind);
            // console.log('[ON TRACK] - info', { peer_id: peer_id, peer_name: peer_name, kind: kind, track: event.track });

            // console.log("******,", event.streams)
            try {


                const track = event.track;
                const settings = track.getSettings();

                // const stream0 = event.streams[0];
                // const stream = event.streams[1];

                // console.log("track.label", track.label)
                // console.log("settings", settings)

                // console.log("stream", stream)
                // if (stream) {
                //     console.log("LISTEN", stream.id)
                //     stream.onremovetrack = (e) => {
                //         console.warn(`Track removed: ${e.track.kind}`);
                //         // socket.emit("peer-track-stopped", { trackId: e.track.id, kind: e.track.kind });
                //     };
                // }


                // console.log("track", track)
                // track.onended = () => {
                //     console.warn(`Track stopped: ${track.kind}`);
                //     // Handle UI updates or notify peers
                //     // socket.emit("peer-track-stopped", { trackId: track.id, kind: track.kind });
                // };

                // console.log("settings", settings)
                // console.log("track", track)
                // console.log(track.label)

                // console.log("settings.displaySurface", settings.displaySurface)
                // let cameras = this.state.cameras

                // event.streams.forEach((strm, index) => {
                // if (event.streams && event.strm) {
                // console.log('[ON TRACK] - peers', peer_id);
                // console.log('[ON TRACK] - strm', strm);
                // remoteVideoStream
                // this.attachMediaStream(peer_id, strm, index)
                let cameras = this.state.cameras
                let indexesToAttach = []

                for (let index = 0; index < event.streams.length; index++) {
                    const strm = event.streams[index];
                    // this.loadRemoteMediaStream(strm, peers, peer_id, index, cameras);
                    this.loadRemoteMediaStream(strm, peer, peer_id, index, cameras, indexesToAttach);

                }

                this.setState({ cameras }, () => {

                    // console.log(cameras)
                    // console.log("indexesToAttach", indexesToAttach)
                    this.setView(0, () => {


                        // setTimeout(() => {
                        //     console.log("SET")
                        //     this.setView(0, () => { })

                        // }, 3000);
                        // setTimeout(() => {
                        //     for (let j = 0; j < cameras.length; j++) {
                        //         if (indexesToAttach.includes(j)) {
                        //             const camera = cameras[j];
                        //             console.log(camera)
                        //             this.attachMediaStream(camera.id, camera.srcObject, j);
                        //         }
                        //     }
                        // }, 100);

                        // setTimeout(() => {
                        //     for (let j = 0; j < cameras.length; j++) {
                        //         const camera = cameras[j];

                        //         this.attachMediaStream(camera.id, camera.srcObject);

                        //     } 
                        // }, 500);


                    })

                })

            } catch (error) {
                console.log("ontrack ERR", error)
            }
            // } else {
            //     console.log('[ON TRACK] - SCREEN SHARING', { peer_id: peer_id, peer_name: peer_name, kind: kind });
            //     // attach newStream with screen share video and audio already existing
            //     // let inboundStream = new MediaStream([event.track, remoteVideoStream.srcObject.getAudioTracks()[0]]);
            //     // this.attachMediaStream(remoteVideoStream, stream);
            //     // this.attachMediaStream(remoteVideoStream,event.streams[1])
            //     // this.attachMediaStream(remoteVideoStream, inboundStream);
            // }
            // })

            // this.setState({cameras})
        }
        // console.log('peerconnection', peerConnections[peer_id].onTrack);

        // this.setState({ peerConnections })
    }
    /**
   * Load Remote Media Stream obj
   * @param {object} stream media stream audio - video
   * @param {object} rawPeer peer info connected to the same room
   * @param {string} peer_id socket.id
   */
    loadRemoteMediaStream = (stream, rawPeer, peer_id, index, cameras, indexesToAttach) => {
        // get data from peers obj

        // console.log("loadRemoteMediaStream", index, peer_id, stream.id)

        // let remoteMediaStream = this.state.remoteMediaStream


        if (!rawPeer) {
            console.log("ERRRRR")
            return
        }
        let peer_name = rawPeer['peer_name'];
        let peer_video = rawPeer['peer_video'];
        let peer_audio = rawPeer['peer_audio'];
        let peer_hand = rawPeer['peer_hand'];
        let peer_rec = rawPeer['peer_rec'];
        let peer_image = rawPeer['peer_image'];
        let peer_username = rawPeer['peer_username'];


        // console.log("rawPeer", rawPeer)


        let peer = { id: peer_id, name: peer_name, peer_id: peer_id, image: peer_image, username: peer_username, video: peer_video, audio: peer_audio, hand: peer_hand, rec: peer_rec }
        // console.log("peer", peer)
        // let remoteMediaStream = stream;

        // console.log('LOAD REMOTE MEDIA STREAM TRACKS - PeerName:[' + peer_name + ']', remoteMediaStream.getTracks());
        // console.log("***stream")
        // console.log(stream)
        // console.log(peer)

        let found = false
        let myPeerId
        let screenShare = false
        // let peerMediaElements = this.state.peerMediaElements

        cameras.forEach(camera => {
            // console.log('camera id', camera.id, peer_id);
            myPeerId = index == 0 ? peer_id : (peer_id + '_shareScreen')
            if (camera.id == myPeerId) {
                found = true
            }

            if (index == 1) {
                screenShare = true
            }

            // console.log('found', found);



        })

        if (!found) {


            // indexesToAttach.push(index)
            stream.onremovetrack = (e) => {
                // console.warn(`Track removed: ${e.track.kind}`);
                // this.removeStreamFromScreen(stream.id)
                // socket.emit("peer-track-stopped", { trackId: e.track.id, kind: e.track.kind });
            };

            // stream.onremovetrack = (e) => {
            //     console.warn("track removed", e)
            // }
            if (index != 0) {

                peer.name = peer_name + ' Presentation'

            }

            if (screenShare) {
                playSound('recStop')
            }

            cameras.push({ id: myPeerId, peer, local: false, stream: stream.id, screenShare, srcObject: new MediaStream(stream), peer_audio, peer_video, peer_hand, peer_rec })

            // console.log('camera stream');
            // if (index == 0) {
            //     // cameras.push({ id: peer_id, peer, local: false, srcObject: remoteMediaStream })

            //     // console.log('camera stream', cameras);
            //     // // this.setState({ cameras, remoteMediaStream }, () => {
            //     // this.setState({ cameras }, () => {

            //     //     console.log('this.roomVideoView', this.roomVideoView)
            //     //     this.setView(0, () => {
            //     //         // console.log('9setView1126')

            //     //         // this.roomVideoView.setView(() => {

            //     //         if (peer_id) {
            //     //             setTimeout(() => {

            //     //                 console.log('myPeerId', peer_id)

            //     //                 let remoteVideoWrap = document.getElementById(myPeerId + '_videoWrap')
            //     //                 peerMediaElements[myPeerId] = remoteVideoWrap;
            //     //                 // this.setState({ peerMediaElements })
            //     //                 this.attachMediaStream(myPeerId, remoteMediaStream);
            //     //             }, 100);

            //     //         }

            //     //         // })

            //     //     })
            //     // })
            // } else {
            //     // console.log('camera Presentation');
            //     peer.name = peer_name + ' Presentation'
            //     // cameras.push({ id: myPeerId, peer, local: false, srcObject: remoteMediaStream })
            //     // this.setState({ cameras }, () => {
            //     //     // if (this.roomVideoView) {
            //     //     //     this.roomVideoView.setView(() => {
            //     //     this.setView(0, () => {
            //     //         console.log('myPeerId1', myPeerId)

            //     //         if (myPeerId) {
            //     //             setTimeout(() => {

            //     //                 let remoteVideoWrap = document.getElementById(myPeerId + '_videoWrap')
            //     //                 // let peerMediaElements = this.state.peerMediaElements
            //     //                 peerMediaElements[myPeerId] = remoteVideoWrap;
            //     //                 // this.setState({ peerMediaElements })
            //     //                 this.attachMediaStream(myPeerId, remoteMediaStream);

            //     //             }, 100);

            //     //         }

            //     //     })
            //     //     // }
            //     // })
            // }

            // cameras.push({ id: myPeerId, peer, local: false, srcObject: remoteMediaStream })

            // console.log('camera stream', cameras);
            // this.setState({ cameras, remoteMediaStream }, () => {
            // this.setState({ cameras }, () => {

            //     console.log('this.roomVideoView', this.roomVideoView)
            //     this.setView(0, () => {
            //         // console.log('9setView1126')

            //         // this.roomVideoView.setView(() => {

            //         // if (peer_id) {
            //         // setTimeout(() => {

            //         console.log('myPeerId', peer_id)

            //         // let remoteVideoWrap = document.getElementById(myPeerId + '_videoWrap')
            //         // peerMediaElements[myPeerId] = remoteVideoWrap;
            //         // this.setState({ peerMediaElements })
            //         this.attachMediaStream(myPeerId, remoteMediaStream);
            //         // }, 100);

            //         // }

            //         // })

            //     })
            // })

        }

        // this.setState({ peerMediaElements })

    }





    setView = (index, cb) => {
        if (this.roomVideoView) {
            // console.log('!setViewSEC', index)
            this.roomVideoView.setView(() => {
                cb()
            })
        }
        else {
            setTimeout(() => {
                // console.log('!setViewERR', index)
                if (index < 40) {
                    this.setView((index + 1), cb)
                } else {
                    if (cb)
                        cb()
                }
            }, 100);
        }
    }






    handleOnIceCandidate = async (peer_id) => {

        let peerConnections = this.peerConnections

        // console.log("handleOnIceCandidate",peer_id)

        peerConnections[peer_id].onicecandidate = (event) => {
            if (!event.candidate) return;

            // console.log("handleOnIceCandidate 1")

            this.sendToServer('roomRelayICE', {
                peer_id: peer_id,
                ice_candidate: {
                    sdpMLineIndex: event.candidate.sdpMLineIndex,
                    sdpMid: event.candidate.sdpMid,
                    candidate: event.candidate.candidate,
                },
            });
        };
        // this.setState({ peerConnections })

    }


    /**
    * Add participants in the chat room lists
    * @param {object} peers all peers info connected to the same room
     */
    msgerAddPeers = async (peers) => {
        // console.log("peers", peers);
        // add all current Participants
        let myPeerId = this.state.myPeerId
        for (let peer_id in peers) {
            let peer_name = peers[peer_id]['peer_name'];
            // bypass insert to myself in the list :)
            if (peer_id != myPeerId) {
                let exsistMsgerPrivateDiv = document.getElementById(peer_id + '_pMsgDiv');
                // if there isn't add it....
                if (!exsistMsgerPrivateDiv) {
                    let msgerPrivateDiv = `
                <div id="${peer_id}_pMsgDiv" class="msger-peer-inputarea">
                    <input
                        id="${peer_id}_pMsgInput"
                        class="msger-input"
                        type="text"
                        placeholder="💬 Enter your message..."
                    />
                    <button id="${peer_id}_pMsgBtn" value="${peer_name}">
                        &nbsp;${peer_name}<i class="fas fa-paper-plane"></i>
                    </button>
                </div>
                `;
                    // msgerCPList.insertAdjacentHTML('beforeend', msgerPrivateDiv);
                    // msgerCPList.scrollTop += 500;

                    let msgerPrivateMsgInput = document.getElementById(peer_id + '_pMsgInput');
                    let msgerPrivateBtn = document.getElementById(peer_id + '_pMsgBtn');
                    // this.addMsgerPrivateBtn(msgerPrivateBtn, msgerPrivateMsgInput);
                }
            }
        }
    }
    retryConnection = async (time = 0, tryTime = 0) => {
        setTimeout(() => {
            console.log('retryConnection', tryTime)

            if (SocketServices.socket?.connected) {
                console.log('retryConnection success')
                Object.values(this.peerConnections).map((peerConnection) => {
                    peerConnection.restartIce()
                })
                // peerConnections[peer_id].restartIce()
            }
            else {
                if (tryTime < 10) {
                    this.retryConnection(time + 5, tryTime + 1)
                }
                else {
                    //
                }

            }
        }, time * 100);

    }
    handlePeersConnectionStatus = async (peer_id) => {
        let peerConnections = this.peerConnections
        peerConnections[peer_id].onconnectionstatechange = (event) => {
            const connectionStatus = event.currentTarget.connectionState;


            if (connectionStatus == 'disconnected') {

                console.log("connectionStatus", peer_id, connectionStatus)

            }

            const signalingState = event.currentTarget.signalingState;
            // console.log('[RTCPeerConnection] - CONNECTION', {
            //     peer_id: peer_id,
            //     connectionStatus: connectionStatus,
            //     signalingState: signalingState,
            // });

            if (connectionStatus == "failed") {
                console.log('RTCPeerConnection disconnected')
                // this.retryConnection(peerConnections, peer_id)

            }
        };
        // this.setState({ peerConnections })

    }

    // setView = (cb) => {
    //     let bound = getBoundingClientRect(this.camerasContainer)
    //     console.log(bound)
    //     console.log(this.state.cameras)

    //     this.tileCalculator(this.state.cameras.length, bound.width, bound.height, () => {

    //         let cameras = this.state.cameras
    //         cameras.forEach(camera => {
    //             if (camera.local) {
    //                 this.localVideo.srcObject = camera.srcObject;
    //             } else {
    //                 if (this[camera.id]) {
    //                     this.attachMediaStream(this[camera.id], camera.srcObject);
    //                 }
    //             }
    //         });



    //         if (cb)
    //             cb()
    //     })
    // }
    /**
    * AttachMediaStream stream to element
    * @param {object} element element to attach the stream
    * @param {object} stream media stream audio - video
    */
    attachMediaStream = (element, stream) => {

        try {

            // console.log("DEPRECATED, attachMediaStream will soon be removed.");
            let videoElement = document.getElementById(element + '_video');
            // console.log(element + '_video')
            // console.log(videoElement)
            // console.log(videoElement)
            // console.log(stream)
            console.log("videoElement", videoElement)


            if (videoElement && videoElement.srcObject == null) {
                // console.log("HEREE!!")
                // videoElement.srcObject = null

                videoElement.srcObject = stream
                // setTimeout(() => {
                // videoElement.stop();
                videoElement.play()
                // }, 0);

                // setTimeout(() => {
                //     videoElement.srcObject = stream
                //     videoElement.play();
                // }, 3000);

                // console.log('Success, media stream attached');

                // console.log(DetectRTC.browser.name);

                if (DetectRTC.browser.name === 'Safari') {
                    /*
                        Hack for Safari...
                        https://www.pilatesanytime.com/Pilates-Help/1016/How-to-Get-Safari-to-Autoplay-Video-and-Audio-Chapters
                    */
                    videoElement.onloadedmetadata = function () {
                        let videoPlayPromise = videoElement.play();
                        if (videoPlayPromise !== undefined) {
                            videoPlayPromise
                                .then(function () {
                                    // console.log('Safari - automatic playback started!');
                                })
                                .catch(function (err) {
                                    // console.error('Safari - automatic playback error', err);
                                });
                        }
                    }
                }


            }

        } catch (error) {
            console.log("attachMediaStream error", error)
        }
    }
    // tileCalculator = (cameras, width, height, cb) => {
    //     let margin = 12

    //     let minSize = 110
    //     let possibilities = []
    //     let final = {}
    //     let positions = []

    //     let maxRows = Math.floor((height / (minSize + margin)))
    //     let maxCols = Math.floor((width / (minSize + margin)))

    //     // console.log(maxRows)
    //     // console.log(maxCols)

    //     let maxCameras = maxRows * maxCols

    //     if (cameras <= maxCameras) {
    //         maxCameras = cameras
    //     }

    //     for (let i = 1; i <= maxCameras; i++) {
    //         let j = Math.ceil(maxCameras / i)
    //         if (i <= maxRows && j <= maxCols) {
    //             possibilities.push({ rows: i, cols: j })
    //         }
    //     }


    //     possibilities.forEach((possibility, index) => {
    //         let res = this.calculatePossibility(possibility, cameras, width, height, margin, minSize)
    //         if (res.valid) {
    //             possibilities[index] = { ...possibility, ...res }
    //             if (final.area < res.area || !final.area) {
    //                 final = possibilities[index]
    //             }
    //         }

    //     });
    //     if (!final.area) {
    //         final = { h: height, w: width, rows: 1, cols: 1, ratio: width / height }
    //     }

    //     let topPoint = (height - (final.rows * final.h + (final.rows - 1 * margin))) / 2
    //     let leftPoint = (width - (final.cols * final.w + (final.cols - 1 * margin))) / 2


    //     for (let i = 0; i < maxCameras; i++) {
    //         let tRow = Math.floor((i) / final.cols)
    //         let tCol = i - (final.cols * tRow)
    //         let w = final.w - margin
    //         let h = final.h - margin
    //         let offset = 0

    //         if (tRow + 1 == final.rows && ((final.cols * final.rows) % maxCameras) != 0) {

    //             offset = ((final.cols * final.rows) - maxCameras)
    //             offset = (offset * (w + margin)) / 2

    //         }

    //         let top = topPoint + (tRow * h) + (tRow * margin)
    //         let left = leftPoint + offset + (tCol * w) + (tCol * margin)


    //         let position = { row: tRow, col: tCol, top, left, w, h }
    //         positions.push(position)

    //     }


    //     // console.log(positions)

    //     this.setState({ positions: positions }, () => {
    //         // this.localVideo.play()
    //         cb()
    //     })

    // }

    handleConnect = async () => {
        // console.log("handleconnecct")
        let localMediaStream = this.localMediaStream
        // console.log(this.state.myPeerId);
        // let myPeerId = this.state.myPeerId
        let myPeerId = SocketServices.socket.id
        // console.log('03. Connected to signaling server');
        this.joinRoom()


        this.setState({ myPeerId }, async () => {
            // console.log('04. My peer id [ ' + myPeerId + ' ]');


            if (localMediaStream) {
                await this.joinToChannel();
                // await this.requestJoinRoom();
            } else {
                // await this.initEnumerateDevices();
                await this.setupLocalMedia();
                await this.whoAreYou();
            }

        })
    }
    // handleScreenShare = () => {
    //     console.log('handleScreenShare')
    //     this.joinToChannel()
    // }
    whoAreYou = async () => {
        // console.log('11. Who are you?');
    }
    getPeerGeoLocation = async () => {
        // console.log('07. Get peer geo location');
        fetch(this.state.peerLoockupUrl)
            .then((res) => res.json())
            .then((outJson) => {
                this.peerGeo = outJson
            })
        // .catch((err) => console.warn(err));
    }
    setupLocalMedia = async () => {
        // if we've already been initialized do nothing
        if (this.localMediaStream != null) {
            return;
        }

        await this.getPeerGeoLocation();

        // console.log('08. Requesting access to local audio - video inputs');
        // console.log('09. Supported constraints', navigator.mediaDevices.getSupportedConstraints());

        // default | qvgaVideo | vgaVideo | hdVideo | fhdVideo | 2kVideo | 4kVideo |
        // let videoConstraints = useVideo ? getVideoConstraints('default') : false;
        // let audioConstraints = useAudio;
        // if (useAudio) {
        //     audioConstraints = {
        //         echoCancellation: true,
        //         noiseSuppression: true,
        //         sampleRate: 44100,
        //     };
        // }

        // const constraints = {
        //     audio: audioConstraints,
        //     video: videoConstraints,
        // };

        // let stream = null;

        // try {
        //     stream = await navigator.mediaDevices.getUserMedia(constraints);
        //     if (stream) {
        //         await loadLocalMedia(stream);
        //         await startPitchDetection(stream);
        //     }
        // } catch (err) {
        //     console.error('[Error] - Access denied for audio - video device', err);
        //     // playSound('alert');
        //     openURL(
        //         `/permission?roomId=${roomId}&getUserMediaError=${err.toString()} <br/> Check the common getusermedia errors <a href="https://blog.addpipe.com/common-getusermedia-errors" target="_blank">here<a/>`,
        //     );
        // }
    } // end [setup_local_stream]


    //locked
    checkPermisions = (config) => {
        // console.log('conf', config);
        let locked = config.locked
        if (locked) {
            return
        }
        // console.log('permision');
        setTimeout(() => {
            this.handleConnect()
        }, 100);
    }



    handleCancelRequest = () => {

        this.sendToServer('roomCancelJoin', { channel: this.state?.roomId }, (feedback) => { })
        // this.setState({ isLoadingJoin: false, requestRejected: false })


    }



    handleJoinRequest = () => {
        // console.log('handleJoinRequest0')
        // SocketServices.socket.on("approveRequet", this.approveRequest)
        // let channel = this.state?.roomId
        this.setState({ isLoadingJoin: true, requestRejected: false })


        let peer_info = {
            // peer_id: peer_id,
            channel: this.state?.roomId,
            userAgent: navigator.userAgent,
            // channel_password: thisRoomPassword,
            peer_info: this.peerInfo,
            peer_geo: this.peerGeo,
            peer_name: this.props.user?.info?.fullname,
            peer_image: this.props.user?.info?.image ? this.props.user?.info?.image[0] : null,
            peer_video: this.state.useVideo,
            peer_audio: this.state.useAudio,
            peer_hand: this.state.myHandStatus,
            peer_rec: this.state.isRecScreenStream,
        }
        // console.log(channel)
        // console.log('peer info', channel);
        this.sendToServer('requestJoinRoom', peer_info, (feedback) => {

            // console.log('feedback', feedback);


            this.setState({ roomIsLocked: feedback.locked })
            if (feedback.locked == false) {

                this.setState({ isLoadingJoin: false, }, () => {
                    this.handleConnect()
                })
            }
        }).then(() => {
            // console.log('requestJoinRoom sent');


        })
    }







    joinApproved = (config) => {

        this.setState({ isLoadingJoin: false })
        if (config.approved) {
            // console.log('approved', config.pending);
            this.setState({ joinPendingRequests: config.pending })
            this.handleJoinRequest()
            // this.handleConnect()
            // console.log('joinPendingRequests', this.state.joinPendingRequests)
            return
        } else {
            this.setState({ requestRejected: true })
        }


    }


    checkApproveRequest = (config, cb) => {
        if (config.channel == this.state.roomId) {

            if (Array.isArray(config.requests) && config.requests.length > 0) {
                // console.log(config.requests)
                playSound('addPeer')
            }
            // console.log('joinPendingRequests2', config)

            // console.log('join request ', config);
            let joinPendingRequests = config.requests
            this.setState({ joinPendingRequests }, () => {
                // console.log('joinPendingRequests2', this.state.joinPendingRequests)

                if (cb)
                    cb()
            })
        }
    }


    approveRequest = (approved, userId) => {
        // console.log('**userId, ', userId);
        let isLoadingApproveRequest = this.state.isLoadingApproveRequest
        isLoadingApproveRequest[userId] = approved
        this.setState({ isLoadingApproveRequest, })

        this.sendToServer('approvedJoinRequest', { channel: this.state.roomId, approved: approved, userId: userId }, () => {

            delete isLoadingApproveRequest[userId]
            this.setState({ isLoadingApproveRequest })

        })
    }





    joinToChannel = async (screenShare = false) => {
        // console.log('12. join to channel', this.state.roomId);
        // let peer_info = {}
        // if (!screenShare) {
        // let peer_id = nanoid()
        let peer_info = {
            id: this.state.myPeerId,
            channel: this.state?.roomId,
            userAgent: navigator.userAgent,
            // channel_password: thisRoomPassword,
            peer_info: this.peerInfo,
            peer_geo: this.peerGeo,
            peer_name: this.props.user?.info?.fullname,
            peer_image: this.props.user?.info?.image ? this.props.user?.info?.image[0] : null,
            peer_video: this.state.useVideo,
            peer_audio: this.state.useAudio,
            peer_hand: this.state.myHandStatus,
            peer_rec: this.state.isRecScreenStream,
        }
        // }

        // else {
        //     // let peer_id = nanoid()

        //     peer_info = {
        //         // peer_id: peer_id,
        //         channel: this.state?.roomId,
        //         // userAgent: navigator.userAgent,
        //         // channel_password: thisRoomPassword,
        //         peer_info: this.peerInfo,
        //         peer_name: this.props.user?.info?.fullname + "- Share Screen",
        //         peer_rec: false,
        //     }
        // }

        // this.sendToServer('roomJoin', peer_info)

        let cameras = this.state.cameras
        cameras.forEach(camera => {
            if (camera.id == 'localVideo') {
                // console.log("FOUND")
                // console.log(camera);
                // console.log(peer_info)
                camera.peer = peer_info
            }
        })
        // console.log(cameras)
        this.setState({ cameras, joinRoomApproved: true, isInRoom: true })

        if (!this.state.connectTopicIsSubscribed) {
            this.setState({ connectTopicIsSubscribed: true })
            SocketServices.addTopic(this.state.topicId, 'connected', 'socket', null, this.socketReconnected)
        }

        // this.roomVideoView.initSetView()
    }




    socketReconnected = () => {
        console.log("socket reconnected")
        this.handleJoinRequest()
    }

    sendToServer = async (msg, config = {}, cb) => {
        // console.log('sthis.state.roomId', this.state.roomId)
        // if (config.channel == this.state.roomId) {

        // console.log("COM: " + msg)
        // console.log("COM: ", config)
        // console.log(SocketServices.socket)
        SocketServices.socket.emit(msg, config, cb);
        // }
    }

    getPeerInfo = () => {
        return {
            detectRTCversion: DetectRTC.version,
            isWebRTCSupported: DetectRTC.isWebRTCSupported,
            isMobileDevice: DetectRTC.isMobileDevice,
            isTabletDevice: this.isTabletDevice,
            isIPadDevice: this.isIPadDevice,
            osName: DetectRTC.osName,
            osVersion: DetectRTC.osVersion,
            browserName: DetectRTC.browser.name,
            browserVersion: DetectRTC.browser.version,
        };
    }

    /**
    * Check if Tablet device
    * @param {object} userAgent info
    * @return {boolean} true/false
    */

    isTablet(userAgent) {
        return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
            userAgent,
        );
    }

    /**
     * Check if IPad device
     * @param {object} userAgent
     * @return {boolean} true/false
     */

    isIpad(userAgent) {
        return /macintosh/.test(userAgent) && 'ontouchend' in document;
    }

    goToLobby = () => {
        this.stagesManager.changeStage('lobby')
    }

    goToReview = () => {
        if (this.stagesManager) {
            this.setState({ isInRoom: false })
            this.stagesManager.changeStage('review')
        }
    }

    joinRoom = () => {
        this.stagesManager.changeStage('room')
        // setTimeout(() => {
        this.initSetView(0)
        // this.roomVideoView?.initSetView()
        // }, 500);
    }

    goToRooms = () => {
        this.props.changeWindow('rooms', { path: ['rooms'] })
    }

    backToRoom = () => {
    }




    toggleMuteAudio = () => {

        // console.log("toggleMuteAudio", this.localMediaStream)
        if (this.localMediaStream) {
            // console.log('useAudio1',)

            this.localMediaStream.getAudioTracks().forEach(function (track) {
                track.enabled = !track.enabled

            });
            let useAudio = this.state.useAudio
            useAudio = !useAudio

            let cameras = this.state.cameras

            for (let c = 0; c < cameras.length; c++) {
                let camera = cameras[c];
                if (camera.id == 'localVideo') {
                    camera.peer_audio = useAudio
                }
            }

            this.setState({ useAudio: useAudio, cameras })

            if (this.state.isInRoom) {
                this.sendMyUpdateToPeers('peer_audio', useAudio)
            }
            // this.props.setData('useAudio', useAudio)
        }

    }



    toggleStopCamera = () => {

        if (this.localMediaStream) {
            // console.log('useAudio1',)

            this.localMediaStream.getVideoTracks().forEach(function (track) {
                track.enabled = !track.enabled
            })
            let useVideo = this.state.useVideo
            useVideo = !useVideo

            let cameras = this.state.cameras

            for (let c = 0; c < cameras.length; c++) {
                let camera = cameras[c];
                if (camera.id == 'localVideo') {
                    camera.peer_audio = useVideo
                }
            }

            this.setState({ useVideo: useVideo, cameras })

            if (this.state.isInRoom) {
                this.sendMyUpdateToPeers('peer_video', useVideo)
            }
            // this.props.setData('useAudio', useAudio)
        }

    }

    toggleRaiseHand = () => {

        let myHandStatus = this.state.myHandStatus
        myHandStatus = !myHandStatus

        let cameras = this.state.cameras

        for (let c = 0; c < cameras.length; c++) {
            let camera = cameras[c];
            if (camera.id == 'localVideo') {
                camera.peer_hand = myHandStatus
            }
        }

        this.setState({ myHandStatus })

        if (this.state.isInRoom) {
            this.sendMyUpdateToPeers('peer_hand', myHandStatus)
        }

    }






    sendEmojiToPeers = (value) => {

        let emojis = this.state.emojis ?? {}

        if (Object.values(emojis).length < 10) {

            if (this.state.isInRoom) {
                this.sendMyUpdateToPeers('peer_emoji', value)
            }

            this.addEmojiToList(value, 'me')

        }
    }




    addEmojiToList = (emoji, peer_id) => {

        console.log("this.state.allPeers", this.state.allPeers, peer_id)
        let emojis = this.state.emojis ?? {}
        let id = nanoid()
        let peer
        if (peer_id == 'me') {
            peer = { peer_id: this.state.myPeerId, peer_name: '{{lang}}Me', peer_image: this.props.user?.info?.image ? this.props.user?.info?.image[0] : null, }
        } else {
            if (Array.isArray(this.state.allPeers)) {
                for (let index = 0; index < this.state.allPeers.length; index++) {
                    const element = this.state.allPeers[index];
                    if (element.peer_id == peer_id) {
                        peer = element
                    }
                }
            }
        }

        let left = Math.floor(Math.random() * 101) + 5;
        emojis[id] = { time: 2, left, type: emoji, id, peer }

        this.setState({ emojis }, () => {
            // console.log(this.state.emoji, 'emoji')
            setTimeout(() => {
                delete emojis[id]
                this.setState({ emojis })
            }, 5000);
        })
        // }

        // console.log(type,prop)

        // this.props.sendEmojiToPeers()
    }



    render() {

        return (

            <div className=" w-100 h-100 window-content-radius " >
                <div className='d-flex w-100 h-100'>
                    {/* <RoomChat /> */}
                    {/* {console.log('dataaaaaa1', this.props.user)} */}
                    <StagesManager ref={el => this.stagesManager = el} height={'100%'} fast={true}>
                        <RoomLobby stage={1} stageName="lobby" language={this.props.language} goToRooms={this.goToRooms} videoOff={this.state.videoOff} useAudio={this.state.useAudio} useVideo={this.state.useVideo} setData={this.setData} user={this.props.user?.info} stream={this.localMediaStream} changePage={this.props.changePage} configConstraints={this.configConstraints} isLoadingJoin={this.state.isLoadingJoin} constraints={this.constraints} joinRoom={this.joinRoom} roomId={this.state.roomId} width={this.props.width} height={this.props.height} ref={el => this.roomLobby = el} localMediaStream={this.localMediaStream} handleJoinRequest={this.handleJoinRequest} handleSocket={this.handleSocket} joinRoomApproved={this.state.joinRoomApproved} roomIsLocked={this.state.roomIsLocked} requestRejected={this.state.requestRejected} toggleMuteAudio={this.toggleMuteAudio} toggleStopCamera={this.toggleStopCamera} />
                        <RoomVideo stage={1} stageName="room" language={this.props.language} peopleList={this.state.peopleList} setPeopleList={this.setPeopleList} information={this.state.information} setInformation={this.setInformation} videoOff={this.state.videoOff} useAudio={this.state.useAudio} useVideo={this.state.useVideo} user={this.props.user?.info} setData={this.setData} goToReview={this.goToReview} roomId={this.state.roomId} width={this.props.width} height={this.props.height} ref={el => this.roomVideoView = el} initClientPeer={this.initClientPeer} handleConnect={this.handleConnect} cameras={this.state.cameras} allPeers={this.state.allPeers} localMediaStream={this.localMediaStream} remoteMediaStream={this.state.remoteMediaStream} handleRtcOffer={this.handleRtcOffer} stream={this.stream} isScreenStreaming={this.isScreenStreaming} myPeerId={this.state.myPeerId} myPeerName={this.props.user?.info?.fullname} peerConnection={this.state.peerConnection} peerConnections={this.peerConnections} setStateProps={this.setStateProps} sendToServer={this.sendToServer} attachMediaStream={this.attachMediaStream} handleSocket={this.handleSocket} handleAddPeer={this.handleAddPeer} joinToChannel={this.joinToChannel} handleRemovePeer={this.handleRemovePeer} initScreenPeer={this.initScreenPeer} handleScreenShare={this.handleScreenShare} UpdateShareScreenToPeers={this.UpdateShareScreenToPeers} handleJoinRequest={this.handleJoinRequest} joinPendingRequests={this.state.joinPendingRequests} approveRequest={this.approveRequest} isLoadingApproveRequest={this.state.isLoadingApproveRequest} initUserMedia={this.initUserMedia} toggleMuteAudio={this.toggleMuteAudio} toggleStopCamera={this.toggleStopCamera} toggleRaiseHand={this.toggleRaiseHand} myHandStatus={this.state.myHandStatus} uniqueHubs={this.state.uniqueHubs} sendEmojiToPeers={this.sendEmojiToPeers} emojis={this.state.emojis} reloadScreenShare={this.reloadScreenShare} />
                        <RoomReview stage={1} stageName="review" language={this.props.language} backToRoom={this.backToRoom} goToRooms={this.goToRooms} roomId={this.state.roomId} width={this.props.width} height={this.props.height} />
                    </StagesManager>
                    {/* <RoomContent roomId={this.state.roomId} /> */}
                    {/* <RoomMediaTable /> */}

                </div>

            </div>

        )
    }
}

// export default Room;
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Room);